<build-section [active]="active"
               [disabled]="disabled"
               [title]="title">

  <ui-choose-motive-section
    *ngIf="isCropping && disabledChooseMotiveModal"
    [imgUrl]="activePrintingUrl"
    (onSubmit)="onImageCropped($event)"
    (onClose)="isCropping = false; activePrinting?.url ? activePrintingUrl = activePrinting?.url : selectNo()"
  ></ui-choose-motive-section>

  <ng-container *ngIf="!isCropping && !isRequired">
    <div class="mb-3"
         *ngFor="let option of options">
      <label class="radio-item radio-primary"
             [class.checked]="option.id === activePrinting?.id">
        <input type="radio"
               [value]="option.id"
               name="motive"
               required
               [formControl]="optionControl"

        />
        <span>{{option.name}}</span>
      </label>
    </div>
  </ng-container>

  <ng-container *ngIf="!isCropping">
    <div [ngBusy]="{busy: imageUploading, message: ('common.pleaseWait' | translate)}">
      <div class="mt-3"
           [hidden]="!activePrinting?.id || !activePrinting?.url">
        <div *ngIf="activePrinting?.id || activePrinting?.url" class="image-container">
          <img [src]="activePrinting?.url"
               [alt]="'cakeBuilder.cakeMotiveSection.title' | translate"
               class="img-fluid pointer motive-image"
               (click)="uploadAction(activePrinting?.url)"/>
        </div>
        <div class="mt-2">
          <button class="btn btn-link text-primary ps-0"
                  (click)="cancel(); chooseNew();">
            <span [translate]="'cakeBuilder.cakeMotiveSection.chooseNew'"></span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="help-text" *ngIf="printingPicture.helpText">{{printingPicture.helpText}}</div>

  <div class="mt-3" *ngIf="!isCropping && isRequired && (!activePrinting?.id || !activePrinting?.url)">
    <button class="btn btn-primary d-flex align-items-center btn-upload-image"
            (click)="selectOption(printingPicture?.id)">
      <i class="icon-upload-images me-2"></i>
      <span class="font-md"
            [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.uploadAnImage'">Upload an image</span>
    </button>
  </div>

</build-section>
